<div class="displayTable">
    <div class="displayTableCell">
  
      <div class="authBlock">
        <h3>Thank You for Registering</h3>
  
        <div class="formGroup" *ngIf="authService.userData as user">
          <p class="text-center">We have sent a confirmation email to <strong>{{user.email}}</strong>.</p>
          <p class="text-center">Please check your email and click on the link to verfiy your email address.</p>
        </div>
        
        
        <div class="formGroup center">
          <button mat-raised-button type="button" class="btn-blue-royal " (click)="authService.SendVerificationMail()">
            <i class="fas fa-redo-alt"></i>
            Resend Verification Email
          </button>
        </div>

        <div class="redirectToLogin" style = "color: black;">

          <h2><span>Verified Email?<span style = "color: blue;" class="redirect" routerLink="/onboard">   Continue</span></span></h2>
        </div>
  
      </div>
  
      
  
    </div>
  </div>